/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const WorkQueueStatus = {
    Pending: 'Pending',
    Todo: 'Todo',
    InProgress: 'InProgress',
    Finished: 'Finished',
    Stopped: 'Stopped',
} as const;

export type WorkQueueStatus = typeof WorkQueueStatus[keyof typeof WorkQueueStatus];



